import { CustomIconProps } from 'assets/Icons/LibraryIcon';
import React from 'react';

const PlayNextIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? 40}
      height={height ?? 40}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M27.4993 30V10H30.8327V30H27.4993ZM9.16602 30V10L24.166 20L9.16602 30ZM12.4993 23.75L18.166 20L12.4993 16.25V23.75Z'
        fill={fill ?? 'white'}
      />
    </svg>
  );
};

export default PlayNextIcon;
